import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface Request {
    month: string | null; // YYYY-MM
}

export interface ResponseData {
    [key: string]: {
        [key: string]: number;
    };
}

export const useGetConsoleQrSystemStatus = ({ month }: Request): UseQueryResult<ResponseData, Error> => {
    let url = enum_api_uri.get_console_qr_system_monthly_status;
    return useQuery({
        queryKey: ["useGetConsoleQrSystemStatus", month],
        queryFn: async () => {
            const response = await axiosInstance.get(url, {
                params: {
                    month,
                },
            });
            return response.data.data;
        },
        enabled: !!month,
    });
};
